module.exports = __webpack_public_path__ + "public/img/bg.d1a1601a.png";